// 1. Function to handle the actual counting animation

const animateCounter = (element) => {
  // Get the final number from the data-target attribute
  const target = +element.getAttribute('data-target');
  const speed = 200; // Animation duration in milliseconds (0.2 seconds * 200 = 40 seconds, so use target / speed as the increment)

  // Calculate the increment value for each step
  const increment = target / speed;
  let count = 0;

  // Use setInterval to update the number repeatedly
  const updateCount = () => {
    count += increment;

    // Check if we've reached or passed the target
    if (count < target) {
      // Display the current count as an integer
      element.innerText = Math.ceil(count).toLocaleString();
      setTimeout(updateCount, 1); // Run every 1ms for smooth animation
    } else {
      // Ensure the final number is the exact target value
      element.innerText = target.toLocaleString();
      clearInterval(counterInterval); // Stop the animation
    }
  };

  // Start counting
  const counterInterval = setTimeout(updateCount, 1);
};


// 2. Intersection Observer Setup

const counterContainer = document.querySelector('.counter-container');

const options = {
  root: null, // viewport
  rootMargin: '0px',
  threshold: 0.5 // trigger when 50% of the element is visible
};

const observerCallback = (entries, observer) => {
  entries.forEach(entry => {
    // If the container is visible
    if (entry.isIntersecting) {
      // Get all counter elements inside the container
      const counterElements = entry.target.querySelectorAll('.counter');

      // Start the animation for each counter
      counterElements.forEach(animateCounter);

      // Stop observing the container once the animation has started
      observer.unobserve(entry.target);
    }
  });
};

const observer = new IntersectionObserver(observerCallback, options);


// Tell the observer to watch the main counter container
if (counterContainer) {
  observer.observe(counterContainer);
}
